import axios from "axios";
import { useNavigate } from "react-router-dom";
import DashNav from "../Dashboard/DashNav.js";
import * as React from "react";
import Stack from "@mui/material/Stack";
import Sidebar from "../Dashboard/Sidebar.js";
import Feed from "../Dashboard/Feed";
import { Box } from "@mui/system";
import customerIcon from "../../Images/customers.svg";
import progressFunnel from "../../Images/funnel-icon.svg";
import openLeadIcon from "../../Images/open-lead-icon.svg";
import dueFollowupIcon from "../../Images/miss-call-icon.svg";
import closedLeadsIcon from "../../Images/closedLeads.svg";
import officeVisitIcon from "../../Images/office-visit.svg"
import avgIVRCallsIcon from "../../Images/avgIVRCallsIcons.svg"
import totalIVRCallsIcons from "../../Images/totalCallsIcons.svg";
import totalIVRMissedCallsAvg from "../../Images/ivrMissedCallsIcon.svg"
import callsIcon from "../../Images/callIcon.svg"
import DatamapsIndia from 'react-datamaps-india'

import {
  Button,
  Chip,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";


import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { ToastContainer, toast } from "react-toastify";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Line } from "react-chartjs-2";
import { Pie } from 'react-chartjs-2';
import { set } from "lodash";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, PointElement, LineElement, Title } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, PointElement, LineElement, Title);

const { DateTime } = require("luxon");

// --- MODERN STYLED COMPONENTS ---

const RootContainer = styled(Box)({
  background: "#F8FAFC",
  minHeight: "100vh",
  display: "flex",
});

const ContentArea = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  marginLeft: "18vw",
  padding: "40px",
  width: "calc(100% - 18vw)",
  transition: "all 0.3s ease",
  [theme.breakpoints.down("md")]: {
    marginLeft: 0,
    width: "100%",
    padding: "20px",
    paddingTop: "84px",
  },
}));

const GlassCard = styled(Paper)({
  padding: "24px",
  borderRadius: "16px",
  background: "#FFFFFF",
  border: "1px solid #E2E8F0",
  boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
});


const StyledDatePicker = styled(DatePicker)(({ theme }) => ({
  color: "inherit",
  "& .css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline":
  {
    borderColor: "grey",
  },
}));
function Reports(props) {
  const navigate = useNavigate();

  return (
    <RootContainer>
      <Sidebar />
      <ReportsComponent />
    </RootContainer>
  );
}
const ReportsComponent = () => {
  const [startDate, setStartDate] = React.useState("");
  const [endDate, setEndDate] = React.useState("");
  const [reportsLoader, setReportsLoader] = React.useState(false);
  const [fetchedReports, setFetchedReports] = React.useState([]);
  const [totalLeadsCount, setTotalLeadsCount] = React.useState(0);
  const [openLeadsCount, setOpenLeadsCount] = React.useState(0);
  const [oProgressLeadsCount, setOnProgressLeadsCount] = React.useState(0);
  const [dueFollowUpsLeadsCount, setDueFollowUpsLeadsCount] = React.useState(0);
  const [closedLeadsCount, setClosedLeadsCount] = React.useState(0);
  const [totalOfficeCount, setTotalOfficeCount] = React.useState(0);
  const [averageIVRCallsPerDay, setAverageIVRCallsPerDay] = React.useState(0);
  const [averageIVRAnsweredCallsPerDay, setAverageIVRAnsweredCallsPerDay] = React.useState(0);
  const [averageIVRMissedCallsPerDay, setAverageIVRMissedCallsPerDay] = React.useState(0);
  const [totalIVRCallsCount, setTotalIVRCallsCount] = React.useState(0);
  const [totalGeoChartData, setTotalGeoChartData] = React.useState([]);
  const [sourceWiseLeadsCount, setSourceWiseLeadsCount] = React.useState([]);
  const [salesExecutiveWiseLeadsCount, setsalesExecutiveWiseLeadsCount] = React.useState([]);
  const [salesConversion, setsalesConversion] = React.useState([]);


  //--------- LEADS Source PIE CHART CUSTOMISATION -----------
  function getLeadsWiseAllLabels(data) {
    return data.map(item => item.leadSource);
  }
  const PieChartLabels = getLeadsWiseAllLabels(sourceWiseLeadsCount);
  function getValuesByKey(data, key) {
    return data.map(item => item[key]);
  }

  const PieChartValues = getValuesByKey(sourceWiseLeadsCount, "lead_count");
  const PieChartData = {
    labels: PieChartLabels,
    datasets: [
      {
        data: PieChartValues,
        backgroundColor: [
          'rgba(0, 123, 255, 0.8)',    // Blue
          'rgba(255, 99, 132, 0.8)',   // Red
          'rgba(75, 192, 192, 0.8)',   // Sea Green
          'rgba(255, 206, 86, 0.8)',   // Yellow
          'rgba(153, 102, 255, 0.8)',  // Purple
          'rgba(54, 162, 235, 0.8)',   // Sky Blue
        ],
        borderWidth: 1, // Border width of the slices
        borderColor: '#fff', // Border color of the slices
        hoverBorderColor: '#000', // Border color when hovering over the slices
      },
    ],
  };
  //------------------------------------------------------------


  //--------- salesExecutive Wise Leads  PIE CHART CUSTOMISATION -----------
  function getsalesExeAllLabels(data) {
    return data.map(item => item.salesExecutive);
  }
  const salesExecutivePieChartLabels = getsalesExeAllLabels(salesExecutiveWiseLeadsCount);
  function getSalesExeValuesByKey(data, key) {
    return data.map(item => item[key]);
  }

  const salesExecutiveChartValues = getSalesExeValuesByKey(salesExecutiveWiseLeadsCount, "lead_count");
  const salesExecutiveChartData = {
    labels: salesExecutivePieChartLabels,
    datasets: [
      {
        data: salesExecutiveChartValues,
        backgroundColor: [
          'rgba(0, 123, 255, 0.8)',    // Blue
          'rgba(255, 99, 132, 0.8)',   // Red
          'rgba(75, 192, 192, 0.8)',   // Sea Green
          'rgba(255, 206, 86, 0.8)',   // Yellow
          'rgba(153, 102, 255, 0.8)',  // Purple
          'rgba(54, 162, 235, 0.8)',   // Sky Blue
        ],
        borderWidth: 1, // Border width of the slices
        borderColor: '#fff', // Border color of the slices
        hoverBorderColor: '#000', // Border color when hovering over the slices
      },
    ],
  };
  //------------------------------------------------------------

  const getReport = async () => {
    setReportsLoader(true);
    const token = localStorage.getItem("accessToken");
    const config = {
      headers: {
        auth: token,
      },
    };

    function isInvalid(value) {
      return value === undefined || value.length === 0;
    }

    if (isInvalid(startDate) || isInvalid(endDate)) {
      toast.error("All fields are mandatory!");
      setReportsLoader(false);
    } else {
      const payload = {
        startDate: startDate.toISODate(),
        endDate: endDate.toISODate(),
      };
      await axios
        .post("/getReport", payload, config)
        .then((response) => {
          toast.success("Reports Fetched Successfully!");
          setFetchedReports(response?.data?.result);
          setTotalLeadsCount(response?.data?.result?.totalLeadsCount);
          setOpenLeadsCount(response?.data?.result?.totalOpenLeadsCount);
          setTotalOfficeCount(response?.data?.result?.totalOfficeVisitCount);
          setAverageIVRCallsPerDay(response?.data.result?.getAverageIVRCalls[0]?.average_calls_per_day)
          setAverageIVRAnsweredCallsPerDay(response?.data.result?.getAverageAnsweredCalls[0]?.average_calls_answered)
          setAverageIVRMissedCallsPerDay(response?.data.result?.getAverageMissedCalls[0]?.average_calls_missed)
          setTotalIVRCallsCount(response?.data?.result?.getTotalIVRCallsCount[0]?.total_answered_calls)
          setOnProgressLeadsCount(
            response?.data?.result?.totalOnProgressLeadsCount
          );
          setDueFollowUpsLeadsCount(
            response?.data?.result?.totalDueFollowupsCount?.count
          );
          setTotalGeoChartData(response?.data?.result?.getGeoLeadsDistributonData);
          setSourceWiseLeadsCount(response?.data?.result?.SouceWiseLeadsCount);
          setsalesExecutiveWiseLeadsCount(response?.data?.result?.salesExecutiveWiseLeadCount);
          setsalesConversion(response?.data?.result?.salesConverstionCount);
          setClosedLeadsCount(response?.data?.result?.totalClosedLeadsCount)
          setReportsLoader(false);
        })
        .catch((err) => {
          console.log(err);
          toast.error("Error while getting report");
          setReportsLoader(false);
        });
    }
  };


  //-------- GEO CHART DATA 
  const regionData = {
    "Andaman & Nicobar Island": {
      value: 0,
      title: "nirbhay",
    },
    "Andhra Pradesh": {
      value: 0,
    },
    "Arunanchal Pradesh": {
      value: 0,
    },
    "Assam": {
      value: 0,
    },
    "Bihar": {
      value: 0,
    },
    "Chandigarh": {
      value: 0,
    },
    "Chhattisgarh": {
      value: 0,
    },
    "Delhi": {
      value: 0,
    },
    "Goa": {
      value: 0,
    },
    "Gujarat": {
      value: 0,
    },
    "Haryana": {
      value: 0,
    },
    "Himachal Pradesh": {
      value: 0,
    },
    "Jammu & Kashmir": {
      value: 0,
    },
    "Jharkhand": {
      value: 0,
    },
    "Karnataka": {
      value: 0,
    },
    "Kerala": {
      value: 0,
    },
    "Lakshadweep": {
      value: 0,
    },
    "Madhya Pradesh": {
      value: 0,
    },
    "Maharashtra": {
      value: 0,
    },
    "Manipur": {
      value: 0,
    },
    "Meghalaya": {
      value: 0,
    },
    "Mizoram": {
      value: 0,
    },
    "Nagaland": {
      value: 0,
    },
    "Odisha": {
      value: 0,
    },
    "Puducherry": {
      value: 0,
    },
    "Punjab": {
      value: 0,
    },
    "Rajasthan": {
      value: 0,
      title: "nirbhay",
    },
    "Sikkim": {
      value: 0,
    },
    "Tamil Nadu": {
      value: 0,
    },
    "Telangana": {
      value: 0,
    },
    "Tripura": {
      value: 0,
    },
    "Uttar Pradesh": {
      value: 0,
    },
    "Uttarakhand": {
      value: 0,
    },
    "West Bengal": {
      value: 0,
    },
  };

  function mergeLeadCountWithRegionData(data, regionData) {
    return Object.keys(regionData).reduce((mergedData, state) => {
      const matchingItem = data.find((item) => item.state === state);

      if (matchingItem) {
        mergedData[state] = { ...regionData[state], value: matchingItem.lead_count };
      } else {
        mergedData[state] = { ...regionData[state], value: 0 };
      }

      return mergedData;
    }, {});
  }

  var geoChartMainData = []
  geoChartMainData = mergeLeadCountWithRegionData(totalGeoChartData, regionData)


  //-------- Sales Conversion Chart Data
  function getsalesConvExeAllLabels(data) {
    return data.map(item => item.month);
  }
  const salesConverstionLabels = getsalesConvExeAllLabels(salesConversion);
  function getSalesConversionExeValuesByKey(data, key) {
    return data.map(item => item[key]);
  }

  const salesConversionValues = getSalesConversionExeValuesByKey(salesConversion, "customer_count");
  const data = {
    labels: salesConverstionLabels.reverse(),
    datasets: [
      {
        label: 'Sales Dataset',
        data: salesConversionValues.reverse(),
        borderColor: '#BA1F21',
        backgroundColor: 'rgba(75,192,192,0.2)',
      },
    ],
  };

  const options = {
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  };

  return (
    <ContentArea>
      <Stack 
        direction={{ xs: "column", md: "row" }} 
        justifyContent="space-between" 
        alignItems={{ xs: "flex-start", md: "center" }} 
        spacing={3}
        sx={{ mb: 4 }}
      >
        <Box>
          <Typography
            variant="h3"
            sx={{
              fontWeight: 800,
              color: "#1E293B",
              fontFamily: "Kamerik",
              letterSpacing: "-1.5px",
              fontSize: { xs: "2rem", md: "3rem" }
            }}
          >
            Reports
          </Typography>
        </Box>
      </Stack>

      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <GlassCard>
              <Stack 
                direction={{ xs: "column", md: "row" }} 
                spacing={2} 
                alignItems={{ xs: "stretch", md: "center" }}
              >
                <LocalizationProvider dateAdapter={AdapterLuxon}>
                  <StyledDatePicker
                    sx={{
                      width: { xs: "100%", md: "30%" },
                      "& .MuiOutlinedInput-root": { borderRadius: "12px" },
                      "& .MuiPickersDay-daySelected": {
                        background: "none",
                        color: "inherit",
                      },
                    }}
                    label="Start Date"
                    name="remindDate"
                    onChange={(newValue) => setStartDate(newValue)}
                  />
                </LocalizationProvider>

                <LocalizationProvider dateAdapter={AdapterLuxon}>
                  <StyledDatePicker
                    sx={{
                      width: { xs: "100%", md: "30%" },
                      "& .MuiOutlinedInput-root": { borderRadius: "12px" },
                      "& .MuiPickersDay-daySelected": {
                        background: "none",
                        color: "inherit",
                      },
                    }}
                    label="End Date"
                    name="remindDate"
                    onChange={(newValue) => setEndDate(newValue)}
                  />
                </LocalizationProvider>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    getReport();
                  }}
                  sx={{
                    height: "56px",
                    borderRadius: "12px",
                    width: { xs: "100%", md: "20%" },
                    fontWeight: 700,
                    bgcolor: "#1E293B",
                    "&:hover": { bgcolor: "#0F172A" },
                  }}
                >
                  Get Report
                </Button>
              </Stack>
            </GlassCard>
          </Grid>
            {/* <Grid item xs={4}>
              <Item></Item>
            </Grid> */}
          <Grid item xs={12} md={7}>
            <GlassCard sx={{ height: "550px" }}>
              <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, color: "#1E293B" }}>Sales Performance Chart</Typography>
               <Box sx={{ height: "450px", position: "relative" }}>
                {
                  reportsLoader ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                        <CircularProgress size="3.5rem" sx={{ color: "#1E293B" }} />
                    </Box>
                  ) : (
                    <Line data={data} options={{ ...options, maintainAspectRatio: false }} />
                  )
                }
               </Box>
            </GlassCard>
          </Grid>
          <Grid item xs={12} md={5}>
            <GlassCard sx={{ height: "550px", overflow: "hidden" }}>
              <Box className="chart-india" sx={{ height: "100%", position: "relative" }}>
                  {
                    reportsLoader ? (
                      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                          <CircularProgress size="3.5rem" sx={{ color: "#1E293B" }} />
                      </Box>
                    ) : (
                      <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      <DatamapsIndia
                        style={{ width: "100%", height: "100%" }}
                        regionData={geoChartMainData}
                        hoverComponent={({ value }) => {
                          return (
                            <Paper sx={{ p: 1, zIndex: 1000, position: 'relative' }}>
                              <div>
                                {value.name} : {value.value}
                              </div>
                            </Paper>
                          );
                        }}
                        mapLayout={{
                          legendTitle: "Leads Distribution",
                          startColor: "#fff",
                          endColor: "#005ce6",
                          hoverTitle: "Count",
                          noDataColor: "#fff",
                          borderColor: "#8D8D8D",
                          hoverColor: "blue",
                          hoverBorderColor: "green",
                          height: 10,
                          weight: 30,
                        }}
                      />
                      </div>
                    )
                  }
              </Box>
            </GlassCard>
          </Grid>
          <Grid item xs={12}>
                <Grid container spacing={2}>
                  {[
                    { title: "Total Leads", count: totalLeadsCount, icon: customerIcon, color: "linear-gradient(195deg, #49a3f1, #1A73E8)" },
                    { title: "Total Open Leads", count: openLeadsCount, icon: openLeadIcon, color: "linear-gradient(195deg, #66BB6A, #43A047)" },
                    { title: "Total On Progress Leads", count: oProgressLeadsCount, icon: progressFunnel, color: "linear-gradient(195deg, #EF5350, #E53935)" },
                    { title: "Total Closed Leads", count: closedLeadsCount, icon: closedLeadsIcon, color: "linear-gradient(195deg, #FFA726, #FB8C00)" },
                    { title: "Total Due Followups", count: dueFollowUpsLeadsCount, icon: dueFollowupIcon, color: "linear-gradient(195deg, #78909C, #546E7A)" },
                    { title: "Total Office Visits", count: totalOfficeCount, icon: officeVisitIcon, color: "linear-gradient(195deg, #EC407A, #D81B60)" },
                    { title: "Avg Total Calls/Day", count: averageIVRCallsPerDay, icon: avgIVRCallsIcon, color: "linear-gradient(195deg, #8D6E63, #6D4C41)" },
                    { title: "Avg Answered Calls/Day", count: averageIVRAnsweredCallsPerDay, icon: totalIVRCallsIcons, color: "linear-gradient(195deg, #5D4037, #3E2723)" },
                    { title: "Avg Missed Calls/Day", count: averageIVRMissedCallsPerDay, icon: totalIVRMissedCallsAvg, color: "linear-gradient(195deg, #C62828, #B71C1C)" },
                    { title: "Total Calls Count", count: totalIVRCallsCount, icon: callsIcon, color: "linear-gradient(195deg, #42A5F5, #1976D2)" },
                  ].map((item, index) => (
                    <Grid item xs={12} sm={6} md={4} lg={2.4} key={index}>
                      <Paper
                        sx={{
                            p: 2,
                            background: item.color,
                            color: "white",
                            borderRadius: "12px",
                            height: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            boxShadow: "0 4px 6px rgba(0,0,0,0.1)"
                        }}
                      >
                         <img
                            style={{ height: "50px", width: "50px", opacity: 0.9 }}
                            src={item.icon}
                            alt={item.title}
                          />
                          <Box sx={{ textAlign: "right" }}>
                            <Typography variant="subtitle2" sx={{ opacity: 0.9, fontWeight: 500 }}>{item.title}</Typography>
                            <Typography variant="h4" sx={{ fontWeight: 700 }}>
                              {reportsLoader ? (
                                <CircularProgress size="1.5rem" style={{ color: "white" }} />
                              ) : (
                                item.count || 0
                              )}
                            </Typography>
                          </Box>
                      </Paper>
                    </Grid>
                  ))}
                </Grid>
          </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <GlassCard>
                  <Box style={{ width: '100%', margin: 'auto', height: "auto" }}>
                    <Typography variant="h6" sx={{ color: "#1E293B", mb: 2, fontWeight: 700, fontFamily: "Kamerik" }}>Leads Source Distribution</Typography>
                    {reportsLoader ? (
                      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '300px' }}>
                          <CircularProgress size="3.5rem" sx={{ color: "#1E293B" }} />
                      </Box>
                    ) : (
                      <Pie data={PieChartData} options={{ responsive: true }} />
                    )

                    }
                  </Box>
              </GlassCard>
            </Grid>

            <Grid item xs={12} md={6} lg={4}>
              <GlassCard>
                <Box>
                    <Typography variant="h6" sx={{ color: "#1E293B", mb: 2, fontWeight: 700, fontFamily: "Kamerik" }}>Sales Executive Leads Distribution</Typography>
                    {reportsLoader ? (
                      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '300px' }}>
                          <CircularProgress size="3.5rem" sx={{ color: "#1E293B" }} />
                      </Box>
                    ) : (
                      <Pie data={salesExecutiveChartData} options={{ responsive: true }} />
                    )

                    }
                </Box>
              </GlassCard>
            </Grid>
          </Grid>
      </Box>
      <ToastContainer />
    </ContentArea>
  );
};
export default Reports;
